'use client';
import Image from 'next/image';

import { InitialSearchInput } from '@/components/static';
import { APP_BASE_PATH, HERO_SECTION_SEARCH_INPUT_ID } from '@/constant/common';
import { PLATFORMS } from '@/constant/common';
import { useCurrentPlatform } from '@/hooks/useCurrentPlatform';
import { equals } from '@/utils/common';

import s from './styles.module.scss';

const getBgPath = (platform: string) => {
  if (equals(platform, PLATFORMS.evolution)) return `${APP_BASE_PATH}/hero-bg-evolution.png`;
  return `${APP_BASE_PATH}/hero-bg-ml-space.png`;
};

export function HeaderHeroSection() {
  const platform = useCurrentPlatform();
  return (
    <div className={s.hero_title_wrapper}>
      <h1 className={s.hero_title}>
        Документация <br /> Cloud.ru {platform}
      </h1>

      <Image
        priority
        quality={100}
        alt='bg_img'
        width={372}
        height={300}
        src={getBgPath(platform)}
        className={s.hero_bg_img}
      />

      <InitialSearchInput
        dataTestId={HERO_SECTION_SEARCH_INPUT_ID}
        placeholder={`Поиск по документации ${platform}`}
        size='l'
        className={s.initial_search_input}
        iconClassname={s.initial_search_input_icon}
      />
    </div>
  );
}
